module.exports = __webpack_public_path__ + "img/categories-duvets.a5553b7.png";